<template>
  <div :id="`${source}_crm_properties_toggle`" class="px-4">
    <a-switch
      size="small"
      v-model:checked="isEnabled"
      @change="handleSwitchChange"
      :disabled="readOnly === true"
    />
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import eventBus from "@/src/utils/eventBus.js";

const props = defineProps({
  source: { type: String, required: true, default: "custom_table" },
  row: { type: Object, required: true },
});

const isEnabled = ref(props.row?.overwrite);
const readOnly = computed(() => props.row?.read_only);

const handleSwitchChange = (checked) => {
  const updatedRow = {
    ...props.row,
    overwrite: checked,
    originalOverwrite: props.row.overwrite,
  };
  eventBus.emit("crm-properties-change", updatedRow);
};
</script>
